/*
 * @Author: Nora Galvin
 * @Date: 2020-08-28 17:15:46
 * @Last Modified by: Nora
 * @Last Modified time: 2020-08-28 18:08:00
 */

import type { TypePopUpOptions } from './type';
import template from './template';

/**
 *
 */
export default class SidebarPopUp {
  _$gfLeftSideBar: JQuery;
  _$tabs: JQuery;
  _options: TypePopUpOptions = {
    title: 'Popup Title',
    description: 'Popup Description',
    hideCancel: false,
    primaryButton: {
      class: 'gf_btn-danger',
      hide: false,
      text: 'Primary Button',
    },
    secondaryButton: {
      class: '',
      hide: false,
      text: 'Secondary Button',
    },
  };

  /**
   * Constructor
   * @param options ..
   */
  constructor(options?: TypePopUpOptions) {
    if (options) {
      this._options = options;
    }
    this._$gfLeftSideBar = jQuery('#gfLeftSideBar');
    this._$tabs = jQuery('.simple-tabs');
    this.renderTemplate();
  }

  /**
   * Render template
   */
  renderTemplate(): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;

    const html = template(this._options);
    const $html = $(html);

    // Add event
    $html
      .find('.cancel span')
      .off('click')
      .on('click', function () {
        //  Close popup and emit event
        $html.remove();
        if (_this._options && _this._options.onClosed) {
          _this._options.onClosed();
        }
      });

    // On click primary button
    $html
      .find('button[data-button=primary]')
      .off('click')
      .on('click', function () {
        // Emit event
        $html.remove();
        if (_this._options && _this._options.onClickedPrimary) {
          _this._options.onClickedPrimary();
        }
      });

    // On click secondary button
    $html
      .find('button[data-button=secondary]')
      .off('click')
      .on('click', function () {
        // Close popup and emit event
        $html.remove();
        if (_this._options && _this._options.onClickedSecondary) {
          _this._options.onClickedSecondary();
        }
      });

    if (!this._$tabs.find('.sidebar-popup') || !this._$tabs.find('.sidebar-popup').length) {
      this._$tabs.append($html);
    }

    return;
  }
}
